import { render } from "./CreateTimezone.vue?vue&type=template&id=72680640"
import script from "./CreateTimezone.vue?vue&type=script&lang=js"
export * from "./CreateTimezone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__